// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_44-0";
export var eligibilityCardNotEligible = "_44-1";